/**
 * Created by rhillion on 02/07/2017.
 */
import React, {Component} from 'react';

const Landing = () => (
    <div>
        <h2>Landing</h2>
    </div>
)

export default Landing;


// WEBPACK FOOTER //
// ./src/Landing.js